import React from "react";
import "../elevate/elevate.css";
import logo from "../assets/Humd Logo 300px-01.jpg";

const HIGHLIGHTS = [
  {
    num: "01",
    title: "90% annual customer retention",
    desc: "Retained customers grew their spend 79% year-on-year. LTV:CAC improved from 8.3x to 24.9x in 12 months.",
  },
  {
    num: "02",
    title: "Saudi Arabia: AED 90K in 3 months",
    desc: "Zero marketing spend, zero local infrastructure. Revenue grew 6x organically. Full launch Q3 2026.",
  },
  {
    num: "03",
    title: "150+ vendor partners pipeline already paid for",
    desc: "Relationships built over 3 years of working together. The cost of acquiring Humd Studio's first customers is effectively already paid.",
  },
];

const STATS = [
  { val: "2.5M+", lbl: "Products\nDelivered" },
  { val: "90%", lbl: "Annual\nRetention" },
  { val: "24.9x", lbl: "LTV:CAC\nRatio" },
  { val: "150+", lbl: "Vendor\nPartners" },
];

const FOOTER_LINKS = [
  { label: "humd.ae", url: "https://humd.ae" },
  { label: "humd.me", url: "https://humd.me" },
  { label: "humd.co", url: "https://humd.co" },
];

export default function Elevate() {
  return (
    <div className="elevate-scope">
      <div className="elv-wrap">
        <header className="elv-header">
          <img src={logo} alt="HUMD" className="elv-logo-img" />
          <span className="elv-header-pill">Seed Round · 2026</span>
        </header>

        <div className="elv-hero">
          <div className="elv-ghost-number">2.5M</div>
          <div className="elv-eyebrow">Investor Teaser</div>
          <h1 className="elv-h1">
            We delivered <em>2.5 million</em>
            <br />
            products to 1,000+
            <br />
            companies without owning
            <br />a single shop or machine.
          </h1>
          <p className="elv-hero-sub">
            Now we're selling the engine that made it possible.
          </p>
        </div>

        <div className="elv-label">What We Do</div>
        <div className="elv-body-text">
          <p>
            <strong>HUMD</strong> digitises the print, packaging &amp; corporate
            gifting industry, starting in the GCC and built for the world. A
            $16-19B market where 90% of manufacturers still run on WhatsApp and
            Excel.
          </p>
          <p>
            Revenue from commission on marketplace orders and monthly SaaS
            subscriptions from vendors (AED 499-4,999/month).{" "}
            <strong>
              AED 1.18M revenue in 2025, up 69% year-on-year, self-funded
              throughout.
            </strong>
          </p>
        </div>

        <div className="elv-label">Recent Highlights</div>
        <div className="elv-highlights">
          {HIGHLIGHTS.map((hl) => (
            <div className="elv-hl" key={hl.num}>
              <div className="elv-hl-num">{hl.num}</div>
              <div className="elv-hl-body">
                <div className="elv-hl-title">{hl.title}</div>
                <div className="elv-hl-desc">{hl.desc}</div>
              </div>
            </div>
          ))}
        </div>

        <div className="elv-stat-band">
          {STATS.map((s, i) => (
            <div className="elv-stat-item" key={i}>
              <div className="elv-stat-val">{s.val}</div>
              <div className="elv-stat-lbl">
                {s.lbl.split("\n").map((line, j) => (
                  <React.Fragment key={j}>
                    {line}
                    {j === 0 && <br />}
                  </React.Fragment>
                ))}
              </div>
            </div>
          ))}
        </div>

        <div className="elv-ask">
          <div className="elv-ask-amount-block">
            <div className="elv-ask-val">$1M</div>
            <div className="elv-ask-tag">Seed Round · 2026</div>
          </div>
          <div className="elv-ask-body">
            <p>
              HUMD is raising a <strong>seed round of $1M in 2026</strong> to
              launch Humd Studio, complete the Saudi Arabia full launch, and
              grow the team. Combined target: <strong>AED 2.25M+.</strong>
            </p>
          </div>
        </div>

        <div className="elv-founder">
          <div className="elv-founder-bar" />
          <div>
            <p className="elv-founder-quote">
              <strong>Vardha &amp; Zak</strong> spent three years operating the
              marketplace manually 436+ factory visits, processing every order
              by hand before building the software. The product is not built
              from assumptions. It is built from three years of doing the work.
            </p>
            <div className="elv-founder-attr">
              Vardha Fazal &amp; Zak Co-founders, HUMD
            </div>
          </div>
        </div>

        <div className="elv-cta-section">
          <div className="elv-cta-pre">Get in touch</div>
          <a
            href="https://calendly.com/humd-sales/30min?month=2026-04"
            target="_blank"
            rel="noopener noreferrer"
            className="elv-cta-btn"
          >
            Request a conversation <span className="elv-cta-arrow">→</span>
          </a>
          <div className="elv-cta-sub">We respond within 24 hours.</div>
          <div className="elv-cta-alt">
            Or write directly{" "}
            <a href="mailto:teamhumd@humd.co">teamhumd@humd.co</a>
          </div>
        </div>

        <footer className="elv-footer">
          <div className="elv-f-sig">
            <strong>Vardha, Zak</strong> &amp; the Humd team · 2026 ·
            Confidential
          </div>
          <div className="elv-f-links">
            {FOOTER_LINKS.map((d) => (
              <a key={d.label} href={d.url} target="_blank" rel="noreferrer">
                {d.label}
              </a>
            ))}
          </div>
        </footer>
      </div>
    </div>
  );
}
